import {styled} from 'styled-components'

export const SvgWrapper = styled.svg`
  pointer-events: none;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
`
